import type { FC } from 'react';
import { REGISTRATIONS_CLOSED, CLOSED_NOTE } from '@/lib/registrationsClosed';

interface ClosedNoticeProps {
  className?: string;
}

/**
 * Muted inline note shown where a registration CTA used to sit.
 * Renders nothing while registrations are open, so call sites can drop it in
 * unconditionally next to their existing button.
 */
export const ClosedNotice: FC<ClosedNoticeProps> = ({ className = '' }) => {
  if (!REGISTRATIONS_CLOSED) return null;

  return (
    <p className={`text-sm text-white/70 ${className}`.trim()}>
      {CLOSED_NOTE}
    </p>
  );
};
